import type { AnchorHTMLAttributes, MouseEvent } from "react";

const APP_NAVIGATION_EVENT = "doorway:navigate";

export function currentAppLocation(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function subscribeToNavigation(listener: () => void): () => void {
  window.addEventListener("popstate", listener);
  window.addEventListener(APP_NAVIGATION_EVENT, listener);
  return () => {
    window.removeEventListener("popstate", listener);
    window.removeEventListener(APP_NAVIGATION_EVENT, listener);
  };
}

export function workspacePath(workspaceId?: string): string {
  return workspaceId ? `/manage/workspaces/${encodeURIComponent(workspaceId)}` : "/manage/workspaces";
}

export function navigateTo(href: string): void {
  const next = new URL(href, window.location.href);
  window.history.pushState(null, "", `${next.pathname}${next.search}${next.hash}`);
  window.dispatchEvent(new Event(APP_NAVIGATION_EVENT));
}

export function AppLink({ href = "", onClick, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
      || event.currentTarget.target === "_blank"
    ) return;
    const target = new URL(href, window.location.href);
    if (target.origin !== window.location.origin) return;
    event.preventDefault();
    navigateTo(href);
  };

  return <a {...props} href={href} onClick={handleClick} />;
}
